import React from "react";
import ReactDOM from "react-dom";
import Routes from "./Routes";
// import * as serviceWorker from "./serviceWorker";
import store from "./configStore";
import "./index.scss";

// let auth_token=localStorage.getItem('auth_Token');

// // store.dispatch(storePrevLocation());
// auth_token && store.dispatch(loginSuccess({authToken:auth_token}));

//-----------------------------------------------------------------------------
function render() {
  ReactDOM.render(<Routes store={store} />, document.getElementById("root"));
}
// inicializarFirebase();

store.subscribe(render);
render();

// serviceWorker.register();
